import Header from './components/Header';
import Hero from './components/Hero';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import TopicsSection from './components/TopicsSection';
import RankingSection from './components/RankingSection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CardsSection />
        <ContactSection />
        <IndexSection />
        <UpdatesSection />
        <CarouselSection />
        <AppSection />
        <CommentsSection />
        <MediaSection />
        <TopicsSection />
        <RankingSection />
        <AboutSection />
        <FeaturesSection />
        <FaqSection />
      </main>
      <Footer />
    </>
  );
}